module.exports = __webpack_public_path__ + "img/f.bc3f0426.png";